import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CodeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Code",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.99 9.42a1.4 1.4 0 0 0-1.98 0l-5.6 5.6a1.4 1.4 0 0 0 0 1.98l5.6 5.6c.25.25.6.41.99.41.77 0 1.4-.63 1.4-1.4 0-.39-.16-.74-.41-.99l-4.61-4.61 4.61-4.6a1.4 1.4 0 0 0 0-1.98Zm14 0c-.25-.25-.6-.41-.99-.41-.77 0-1.4.63-1.4 1.4 0 .39.16.74.41.99l4.61 4.6-4.61 4.61c-.25.25-.41.6-.41.99 0 .77.63 1.4 1.4 1.4.39 0 .74-.16.99-.41l5.6-5.6a1.4 1.4 0 0 0 0-1.98l-5.6-5.6Zm-5.85-4.11a1.397 1.397 0 0 0-1.65 1.08s-3.73 18.67-3.73 18.67a1.397 1.397 0 0 0 1.08 1.65s.09 0 .14 0h.15c.67 0 1.24-.48 1.37-1.12s3.73-18.67 3.73-18.67a1.405 1.405 0 0 0-1.09-1.62Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.1 27.71a1.145 1.145 0 0 1-1.11-1.44L17.5 5.7c.16-.61.79-.97 1.4-.81s.97.79.81 1.4L14.2 26.86c-.14.51-.6.85-1.1.85M24.43 23.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l5.48-5.48-5.48-5.48c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l6.29 6.29c.45.45.45 1.17 0 1.62l-6.29 6.29c-.22.22-.52.33-.81.33M7.29 23.71c-.29 0-.58-.11-.81-.33L.19 17.09a1.16 1.16 0 0 1 0-1.62l6.29-6.29c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-5.48 5.48 5.48 5.48a1.14 1.14 0 0 1-.81 1.95"
      })
    })
  }));
};
CodeIcon.displayName = 'CodeIcon';